import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import useBreakpoints from 'hooks/useBreakpoints';
import { useFetchUserAnalysisSkills, useFetchUserSkillAnalysis } from 'actions/users';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import getHelixGraphTooltip from 'utils/helix/getHelixGraphTooltip';
import { isHelixAndLearningHub } from 'utils/helix/isHelixAndLearningHub';
import EmptyStateController from 'components/EmptyStateController';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
import GraphCard from 'components/GraphCard';
import Heading from 'components/Heading';
import UserGeneratedText from 'components/UserGeneratedText';
import Flex, { Box } from 'components/Flex';
import SkillPageWrapper from '../components/SkillPageWrapper';
import QuoteSection from '../components/QuoteSection';
import MeetingSection from '../components/MeetingSection';
import SkillContentSection from '../components/SkillContentSection';
import HeadingWithFilter from '../components/HeadingWithFilter';
import ButtonRow from '../components/ButtonRow';
import { SummaryFlagCard } from '..';
function SkillAnalysisPage(_ref) {
  var _skillGraphData$skill, _skillGraphData$skill2, _skillGraphData$skill3, _skillGraphData$skill4, _skillGraphData$dates, _skillGraphData$dates2, _skill$skillUsage, _skill$skillUsage2, _skill$userMeetings$l, _skill$userMeetings;
  var isCurrentUser = _ref.isCurrentUser,
    weeksLoading = _ref.weeksLoading,
    weeksError = _ref.weeksError,
    userId = _ref.userId,
    user = _ref.user,
    weekCommencing = _ref.weekCommencing,
    _ref$weeks = _ref.weeks,
    weeks = _ref$weeks === void 0 ? [] : _ref$weeks,
    getUserSkillLocation = _ref.getUserSkillLocation,
    setWeekCommencing = _ref.setWeekCommencing;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useParams = useParams(),
    skillId = _useParams.skillId;
  var selected = weekCommencing || weeks[0];
  var _useFetchUserSkillAna = useFetchUserSkillAnalysis({
      userId: userId,
      skillId: skillId,
      weekCommencingDate: weekCommencing
    }),
    skill = _useFetchUserSkillAna.data,
    skillsLoading = _useFetchUserSkillAna.isLoading,
    skillsError = _useFetchUserSkillAna.isError;
  var _useFetchUserAnalysis = useFetchUserAnalysisSkills({
      userId: userId,
      skillId: skillId,
      weekCommencingDate: selected
    }),
    skillGraphData = _useFetchUserAnalysis.data,
    skillGraphDataLoading = _useFetchUserAnalysis.isLoading,
    skillGraphDataError = _useFetchUserAnalysis.isError;
  var skillName = (skill === null || skill === void 0 ? void 0 : skill.name) || (skillGraphData === null || skillGraphData === void 0 ? void 0 : (_skillGraphData$skill = skillGraphData.skills) === null || _skillGraphData$skill === void 0 ? void 0 : (_skillGraphData$skill2 = _skillGraphData$skill[0]) === null || _skillGraphData$skill2 === void 0 ? void 0 : _skillGraphData$skill2.name);
  var isLoading = weeksLoading || skillsLoading || skillGraphDataLoading;
  var isError = weeksError || skillsError || skillGraphDataError;
  var _ref2 = (_skillGraphData$skill3 = skillGraphData === null || skillGraphData === void 0 ? void 0 : (_skillGraphData$skill4 = skillGraphData.skills) === null || _skillGraphData$skill4 === void 0 ? void 0 : _skillGraphData$skill4[0]) !== null && _skillGraphData$skill3 !== void 0 ? _skillGraphData$skill3 : {},
    scoreEachWeek = _ref2.scoreEachWeek;
  var graphScores = Array.isArray(scoreEachWeek) ? scoreEachWeek.filter(Number.isFinite) : [];
  var hasGraphScores = graphScores.length >= 1;
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.xs;
  var hasData = scoreEachWeek && (scoreEachWeek === null || scoreEachWeek === void 0 ? void 0 : scoreEachWeek.filter(function (score) {
    return score !== null;
  }).length) > 0;
  var chartLabels = (skillGraphData === null || skillGraphData === void 0 ? void 0 : (_skillGraphData$dates = skillGraphData.dates) === null || _skillGraphData$dates === void 0 ? void 0 : _skillGraphData$dates.map(function (day) {
    return getLocalisedDate({
      date: day,
      options: {
        month: 'short',
        day: 'numeric'
      }
    }) || '';
  })) || [];
  var chartLabelClicks = (skillGraphData === null || skillGraphData === void 0 ? void 0 : (_skillGraphData$dates2 = skillGraphData.dates) === null || _skillGraphData$dates2 === void 0 ? void 0 : _skillGraphData$dates2.map(function (day) {
    return function () {
      return setWeekCommencing(day);
    };
  })) || [];
  var formattedSelected = getLocalisedDate({
    date: selected,
    options: {
      month: 'short',
      day: 'numeric'
    }
  });
  var chartOptions = {
    axisY: {
      showLabel: hasData,
      labelInterpolationFnc: function labelInterpolationFnc(value) {
        return "".concat(Math.round(value), "%");
      },
      showGrid: false,
      low: 0,
      high: 100,
      onlyInteger: true
    }
  };
  var positiveSkillUsage = (skill === null || skill === void 0 ? void 0 : (_skill$skillUsage = skill.skillUsage) === null || _skill$skillUsage === void 0 ? void 0 : _skill$skillUsage.positive) || [];
  var negativeSkillUsage = (skill === null || skill === void 0 ? void 0 : (_skill$skillUsage2 = skill.skillUsage) === null || _skill$skillUsage2 === void 0 ? void 0 : _skill$skillUsage2.negative) || [];
  var showButtonRow = isCurrentUser;
  return /*#__PURE__*/React.createElement(SkillPageWrapper, {
    fallbackLink: getUserSkillLocation({}),
    user: user
  }, /*#__PURE__*/React.createElement(HeadingWithFilter, {
    weeks: weeks,
    selected: selected,
    setWeekCommencing: setWeekCommencing,
    title: skillName,
    tooltipContent: skill === null || skill === void 0 ? void 0 : skill.description
  }), /*#__PURE__*/React.createElement(EmptyStateController, {
    isLoading: isLoading,
    isError: isError,
    isEmpty: !skill && !skillGraphData
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "l",
    mt: "m"
  }, hasGraphScores && /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": "graph-heading"
  }, /*#__PURE__*/React.createElement(GraphCard, {
    title: t('property_weekly_progression'),
    chartLabels: chartLabels,
    chartLabelClicks: chartLabelClicks,
    chartData: scoreEachWeek,
    selectedValue: formattedSelected,
    chartHeight: 200,
    options: chartOptions,
    showScore: false,
    getTooltipReadout: getHelixGraphTooltip,
    showAllLabels: isDesktop
  })), /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": "skill-overview-heading"
  }, skill !== null && skill !== void 0 && skill.score && skill !== null && skill !== void 0 && skill.summary ? /*#__PURE__*/React.createElement(SummaryFlagCard, {
    titleId: "skill-overview-heading",
    summary: skill.summary,
    score: skill.score
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, (skill === null || skill === void 0 ? void 0 : skill.suggestion) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h4",
    mb: "xs",
    mt: "s",
    size: "small"
  }, t('property_suggestions')), /*#__PURE__*/React.createElement(UserGeneratedText, {
    text: skill.suggestion
  })), (positiveSkillUsage.length > 0 || negativeSkillUsage.length > 0) && /*#__PURE__*/React.createElement(Box, {
    mt: skill !== null && skill !== void 0 && skill.suggestion ? undefined : 's'
  }, /*#__PURE__*/React.createElement(QuoteSection, {
    skillId: skill.skillId,
    positiveSkillUsage: positiveSkillUsage,
    negativeSkillUsage: negativeSkillUsage,
    getLocation: getUserSkillLocation
  })), showButtonRow && /*#__PURE__*/React.createElement(ButtonRow, {
    isCurrentUser: isCurrentUser,
    showContentButtons: false,
    skillName: skill.name,
    summary: skill.summary,
    suggestion: skill.suggestion
  }))) : /*#__PURE__*/React.createElement(Landmark, {
    height: 100,
    icon: "asset-fluidbook"
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: "s",
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    dimmed: true
  }, t('skills_empty_state_skill_not_recorded_this_week')), showButtonRow && (skill === null || skill === void 0 ? void 0 : skill.name) && /*#__PURE__*/React.createElement(ButtonRow, {
    isCurrentUser: isCurrentUser,
    skillName: skill.name,
    showContentButtons: false
  })))), ((_skill$userMeetings$l = skill === null || skill === void 0 ? void 0 : (_skill$userMeetings = skill.userMeetings) === null || _skill$userMeetings === void 0 ? void 0 : _skill$userMeetings.length) !== null && _skill$userMeetings$l !== void 0 ? _skill$userMeetings$l : 0) > 0 && /*#__PURE__*/React.createElement(MeetingSection, {
    userMeetings: skill === null || skill === void 0 ? void 0 : skill.userMeetings,
    getLocation: getUserSkillLocation
  }), (skill === null || skill === void 0 ? void 0 : skill.name) && isHelixAndLearningHub && /*#__PURE__*/React.createElement(SkillContentSection, {
    isCurrentUser: isCurrentUser,
    userId: userId,
    skillId: skill === null || skill === void 0 ? void 0 : skill.skillId,
    name: skill === null || skill === void 0 ? void 0 : skill.name
  }))));
}
export default SkillAnalysisPage;